
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/rezervovat-zajezd",
      function () {
        return require("private-next-pages/[region]/[resort]/rezervovat-zajezd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/rezervovat-zajezd"])
      });
    }
  